import { render, staticRenderFns } from "./indexLoadCohort.vue?vue&type=template&id=98574154"
import script from "./indexLoadCohort.vue?vue&type=script&lang=js"
export * from "./indexLoadCohort.vue?vue&type=script&lang=js"
import style0 from "./indexLoadCohort.vue?vue&type=style&index=0&id=98574154&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports